import Filter from './filter';

const MIN_GUEST_RATING = 3;
const MAX_GUEST_RATING = 5;
const DELTA = 0.2;

const validateParameters = (lowValue, highValue) => {
    lowValue = +lowValue;
    highValue = +highValue;

    // Checks if the values are within the range and not undefined
    if (!lowValue || lowValue < MIN_GUEST_RATING || lowValue > MAX_GUEST_RATING) {
        lowValue = MIN_GUEST_RATING;
    }
    if(!highValue || highValue < MIN_GUEST_RATING|| highValue > MAX_GUEST_RATING) {
        highValue = MAX_GUEST_RATING;
    }

    // Makes the numbers have only 1 decimal
    lowValue = +("" + Math.abs(lowValue)).substring(0, 3);
    highValue = +("" + Math.abs(highValue)).substring(0, 3);

    // Switches the numbers if min is bigger than max
    if (highValue < lowValue) {
        [highValue, lowValue] = [lowValue, highValue];
    }

    // Checks that the numbers are not too close
    if (highValue - lowValue < 0.2) {
        // NB: We always try to move lowValue if possible
        if (lowValue - MIN_GUEST_RATING >= 0.2) {
            lowValue -= 0.2 - (highValue - lowValue);
        } else {
            highValue += 0.2 - (highValue - lowValue);
        }
    }
    return [lowValue, highValue];
};

export default Filter((FILTER_TYPES) => ({
    id: 'GUEST_RATING',
    queryKey: 'f_guest_rating',
    type: FILTER_TYPES.GUEST_RATING,
    bucketify: (hotel) => {
        const guestRating = hotel?.guestRating;

        if (!guestRating) {
            return undefined;
        }

        // TODO: reactivate for dynamic min/max
        // memory.maxGuestRating = memory.maxGuestRating || 0;
        // memory.minGuestRating = memory.minGuestRating || 5;
        // memory.maxGuestRating = guestRating > memory.maxGuestRating ? guestRating : memory.maxGuestRating;
        // memory.minGuestRating = guestRating < memory.minGuestRating ? guestRating : memory.minGuestRating;

    // TODO: put the id somewhere else (also for price)!
        return {
            bucketId: 'hasGuestRating',
            bucketName: 'guestRating'
        };
    },
    decorateFinalState: (finalState) => {
        finalState.values = finalState.values || {};
        finalState.values.maxGuestRating = MAX_GUEST_RATING; //memory.maxGuestRating;
        finalState.values.minGuestRating = MIN_GUEST_RATING;//memory.minGuestRating;
    },
    toQuery: ({ value }) => {
        const { lowValue, highValue } = value;
        // NB: We set values to undefined if we do NOT want them to be printed to
        //     the query (just lower or upper bound is ok)
        const min = lowValue && lowValue > MIN_GUEST_RATING ? lowValue : undefined;
        const max = highValue && highValue < MAX_GUEST_RATING ? highValue : undefined;

        return `${min || ''}|${max || ''}`;
    },
    fromQuery: (rawQueryValue) => {
        let [lowValue, highValue] = rawQueryValue && 
                                    typeof rawQueryValue.split === 'function' && 
                                    rawQueryValue.split('|') || [MIN_GUEST_RATING, MAX_GUEST_RATING];

        const [validatedLowValue, validatedHighValue] = validateParameters(lowValue, highValue);
        

        return {
            selectedGuestRatings: {
                lowValue: validatedLowValue,
                highValue: validatedHighValue
            }
        };
    },
    reset: (currentState) => {
        return {
            hasGuestRating: currentState?.hasGuestRating,
            minGuestRating: MIN_GUEST_RATING,
            maxGuestRating: MAX_GUEST_RATING
        };
    // NB: We do not want to save selectedDistance since the filter is reset
    //     (slider set to max)
    }
}));
